import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CardMiniEntity } from '../../domain/entities/CardMiniEntity'
import type { CardListedAdminDto } from '@/backend/market'

export class CardMiniModel extends CardMiniEntity {
  constructor(dataDto: CardListedAdminDto) {
    super()
    mapEntityProperties<CardMiniEntity>(this, dataDto)
  }
}
